import { Status } from '@/utils';
import { ERROR_MESSAGE_FIELD } from '@/utils/constants/messages';
import moment from 'moment';
import * as yup from 'yup';

const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
const FILE_SIZE_LIMIT = 10 * 1024 * 1024;

export const formSchemaFn = (
  isActionEdit: boolean,
  isNotPermissionEdit: boolean,
) =>
  yup.object().shape({
    title: yup
      .string()
      .required('タイトルは未入力です。')
      .max(100, 'タイトルは100文字以内で入力してください。'),
    message: yup
      .string()
      .required('本文は未入力です。')
      .max(10000, '本文は10000文字以内で入力してください。'),
    status: yup
      .number()
      .oneOf([0, 1], 'ステータスが不正です。')
      .required('ステータスは必須です。')
      .typeError('ステータスが不正です。'),
    prevStatus: yup.number().optional(),
    publicAt: yup.date().nullable().optional(),
    startAt: yup
      .date()
      .required('発信日時を選択してください。')
      .when(['status', 'prevStatus', 'publicAt'], ([status, prevStatus, publicAt], schema) => {
        if (publicAt) return schema; // Bỏ qua validation nếu publicAt có value
        if (status !== Status.PUBLIC) return schema;
        return schema.min(
          moment().add(1, 'minute').startOf('minute').toDate(),
          isActionEdit
            ? '発信日時が過去の日時になっています。'
            : '発信日時が過去の日時になっています。',
        );
      }),
    attachment: yup
      .mixed()
      .when(['attachments', 'image'], ([attachments, image], schema) => {
        if (image && (!attachments || !attachments?.fileList?.length)) {
          return schema;
        }
        if (!attachments || !attachments?.fileList?.length) {
          return schema;
        }
        return schema
          .test('fileSize', '画像のサイズは10MBを超えています。', (_) => {
            return attachments?.fileList[0]?.size <= FILE_SIZE_LIMIT;
          })
          .test(
            'fileType',
            '画像は .jpg、.png、.jpeg 形式ではありません。',
            (_) => {
              return SUPPORTED_FORMATS.includes(attachments?.fileList[0]?.type);
            },
          );
      }),
    sourceType: yup.string().nullable().optional(),
    sourceId: yup
      .number()
      .nullable()
      .when('sourceType', {
        is: (value: string | null | undefined) => value !== null && value !== undefined && value !== '',
        then: (schema) => schema.required('ソースを選択してください。'),
        otherwise: (schema) => schema.nullable().optional(),
      }),
    url: yup
      .string()
      .nullable()
      .optional()
      .test('url-or-empty', 'URLは正しい形式で入力してください。', (value) => {
        if (!value || value.trim() === '') {
          return true;
        }
        try {
          new URL(value);
          return true;
        } catch {
          return false;
        }
      })
      .max(2000, 'URLは2000文字以内で入力してください。'),
  } as any);

